import { FlashbarProps } from "@amzn/awsui-components-react";

export interface AdminBanner {
    preferenceId: string;
    label: string;
    createdBy: string;
    information: {
        bannerMessage: string;
        bannerType: {
            value: FlashbarProps.Type;
        };
        dismissible: boolean;
    };
}

export interface AdminBannerFromPreference {
    preferenceId: string;
    label: string;
    createdBy: string;
    information: string;
}

export interface PreferenceSuccessResponse {
    data: {
        listPreference: {
            items: AdminBannerFromPreference[]
        }
    }
}

export interface PreferenceByTypeSuccessResponse {
    data: {
        listPreferenceByPreferenceType: {
            items: AdminBannerFromPreference[]
        }
    }
}

export type BannerAssociationId = number | string;

export enum BannerDisplayLocation {
    Everywhere = "Everywhere",
    App = "App",
    ClosePortal = "ClosePortal",
    Microservice = "Microservice",
    UrlPrefix = "UrlPrefix"
}

export interface BannerParameters {
    closePortalOwnerId?: string;
    appId?: string;
    microserviceId?: string;
    microserviceAction?: string;
    urlPrefix?: string;
}

export interface BannerContainerProps {
    roundedCorners: boolean;
    displayLocations: BannerDisplayLocation[];
    parameters?: BannerParameters
}

export interface BannerPropsOptions {
    roundedCorners?: boolean
    onDismiss?: () => void;
}

export interface BannerProps {
    bannerType: FlashbarProps.Type;
    bannerMessage: string;
    bannerKey: string;
    options?: BannerPropsOptions
}

export interface UrlPrefix {
    label: string;
};

export interface BannerCustomMultiInputProps {
    updateInputs: (arg: UrlPrefix[]) => void;
    getInputs: () => UrlPrefix[];
}
